var HttpCodeEnum;
(function (HttpCodeEnum) {
    HttpCodeEnum[HttpCodeEnum["HTTP_200_OK"] = 200] = "HTTP_200_OK";
    HttpCodeEnum[HttpCodeEnum["HTTP_201_CREATED"] = 201] = "HTTP_201_CREATED";
    HttpCodeEnum[HttpCodeEnum["HTTP_400_BAD_REQUEST"] = 400] = "HTTP_400_BAD_REQUEST";
    HttpCodeEnum[HttpCodeEnum["HTTP_401_UNAUTHORIZED"] = 401] = "HTTP_401_UNAUTHORIZED";
    HttpCodeEnum[HttpCodeEnum["HTTP_404_NOT_FOUND"] = 404] = "HTTP_404_NOT_FOUND";
    HttpCodeEnum[HttpCodeEnum["HTTP_409_CONFLICT"] = 409] = "HTTP_409_CONFLICT";
    HttpCodeEnum[HttpCodeEnum["HTTP_500_INTERNAL_SERVER_ERROR"] = 500] = "HTTP_500_INTERNAL_SERVER_ERROR";
})(HttpCodeEnum || (HttpCodeEnum = {}));
var UNEXPECTED_SERVER_ERROR = 'Unexpected server error. Please try again.';

export { HttpCodeEnum, UNEXPECTED_SERVER_ERROR };
//# sourceMappingURL=api.esm.js.map
